import { HistoryRouterPlugin } from '../common/twshared/services/HistoryRouterPlugin';

angular.module('tromanWeb', ['ui.router', 'ui.bootstrap', 'smart-table', 'ui.sortable', 'twshared']);

angular.module('tromanWeb').config(['$logProvider', function ($logProvider) {
    $logProvider.debugEnabled(false);
}]);

angular.module('tromanWeb').config(['$locationProvider', '$uiRouterProvider', function ($locationProvider, $uiRouterProvider) {
    $locationProvider.html5Mode(true);
    $uiRouterProvider.plugin(HistoryRouterPlugin);
}]);

angular.module('tromanWeb').config(['stConfig', function (stConfig) {
    stConfig.sort.skipNatural = true;
    stConfig.sort.delay = 0;
    stConfig.pagination.template = 'template/tw/pagination.html'; // Only supports URL template, "required" in $templateCache below.
}]);
angular.module('tromanWeb').run(['$templateCache', function ($templateCache) {
    $templateCache.put('template/tw/pagination.html', require('./directives/pagination.html'));
}]);

angular.module('tromanWeb').config(['authenticationServiceProvider', function (authenticationServiceProvider) {
    authenticationServiceProvider.unauthorized = ['authenticationService', function (authenticationService) {
        authenticationService.logout();
        location.href = "../";
    }];
}]);

angular.module('tromanWeb').config(['$stateProvider', '$urlRouterProvider', '$urlMatcherFactoryProvider', 'isTroman', function ($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider, isTroman) {

    $urlMatcherFactoryProvider.type('guid', {
        pattern: /[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}/
    });

    $stateProvider.state('authenticated', {
        abstract: true,
        resolve: {
            systemInfo: ['$q', 'tromanServer', '$rootScope', 'tromanGlobals', function ($q, tromanServer, $rootScope, tromanGlobals) {
                return tromanServer.System.getInfo()
                    .then(function (value) {
                        tromanGlobals.systemInfo = value;
                        $rootScope.$shared = $rootScope.$shared || {};
                        $rootScope.$shared.acceptAttachments = value.AttachmentExtensions?.join(',');
                        $rootScope.$shared.acceptImages = value.ImageExtensions?.join(',');
                        return value;
                    })
                    .catch(function (err) {
                        // TODO Detect difference between 401 and any other errors.
                        location.href = "../";
                        return $q.reject(err);
                    });
            }],
            userProfile: ['$q', 'accountServer', 'tromanGlobals', function ($q, accountServer, tromanGlobals) {
                return accountServer.Profile.getProfile()
                    .then(function (value) {
                        tromanGlobals.userProfile = value;
                        return value;
                    })
                    .catch(function (err) {
                        // TODO Detect difference between 401 and any other errors.
                        location.href = "../";
                        return $q.reject(err);
                    });
            }]
        },
        onExit: ['tromanGlobals', function (tromanGlobals) {
            tromanGlobals.systemInfo = null;
            tromanGlobals.userProfile = null;
        }],
        views: {
            'navbar': {
                controller: "NavbarController as navctrl",
                template: require("./navbar/navbar.html")
            },
            'main': {
                template: '<div class="pageRoot" data-ui-view=""></div>'
            }
        }
    });

    $stateProvider.state('front', {
        parent: 'authenticated',
        url: '/',
        controller: "FrontController as ctrl",
        template: require('./front/front.html')
    });

    $stateProvider.state('profile', {
        parent: 'authenticated',
        url: "/profile",
        controller: "ProfileController as ctrl",
        template: require('./profile/profile.html'),
        data: { title: "Kontoinformation" }
    });

    $stateProvider.state("persons", {
        parent: 'authenticated',
        url: "/persons",
        controller: "PersonsController as ctrl",
        template: require('./persons/persons.html'),
        data: { title: "Personer" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("addperson", {
        parent: 'authenticated',
        url: "/persons/add",
        abstract: true,
        controller: "PersonController as pc",
        template: require('./persons/addperson.html'),
        data: { title: "Lägg till person" },
        resolve: {
            personState: ['PersonState', function (PersonState) {
                return PersonState.create();
            }]
        }
    });

    $stateProvider.state("addperson.details", {
        url: "",
        controller: "PersonEditController as pec",
        template: require('./persons/person.details.html')
    });

    $stateProvider.state("person", {
        parent: 'authenticated',
        url: "/persons/{personId:guid}",
        abstract: true,
        controller: "PersonController as pc",
        template: require('./persons/person.html'),
        data: { title: "Personuppgifter" },
        resolve: {
            personState: ['$transition$', 'PersonState', function ($transition$, PersonState) {
                return PersonState.create($transition$.params().personId);
            }]
        }
    });

    $stateProvider.state("person.details", {
        url: "",
        controller: "PersonEditController as pec",
        template: require('./persons/person.details.html')
    });

    $stateProvider.state("person.files", {
        url: "/files",
        controller: "PersonFilesController as pfc",
        template: require('./persons/person.files.html')
    });

    $stateProvider.state("person.missions", {
        url: "/missions",
        controller: "PersonMissionsController as pmc",
        template: require('./persons/person.missions.html')
    });

    $stateProvider.state("person.tromanpublik", {
        url: "/tromanpublik",
        controller: "PersonEditController as pec",
        template: require('./persons/person.publish.html')
    });

    $stateProvider.state("person.equipment", {
        url: "/equipment",
        controller: "PersonEquipmentController as pec",
        template: require('./persons/person.equipment.html')
    });

    $stateProvider.state("person.awards", {
        url: "/awards",
        controller: "PersonAwardsController as pac",
        template: require('./persons/person.awards.html')
    });

    $stateProvider.state("person.payroll", {
        url: "/payroll",
        controller: "PersonEditController as pec",
        template: require('./persons/person.payroll.html')
    });

    $stateProvider.state("person.politiker", {
        url: "/politiker",
        controller: "PersonEditController as pec",
        template: require('./persons/person.politiker.html')
    });

    $stateProvider.state("organizations", {
        parent: 'authenticated',
        url: "/organizations",
        controller: "OrganizationsController as ctrl",
        template: require('./organizations/organizations.html'),
        data: { title: "Organisationer" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        },
    });

    $stateProvider.state("organization", {
        parent: 'authenticated',
        url: "/organizations/{organizationId:guid}",
        abstract: true,
        controller: "OrganizationController as oc",
        template: require('./organizations/organization.html'),
        data: { title: "Organisation" },
        resolve: {
            organizationState: ['$transition$', 'OrganizationState', function ($transition$, OrganizationState) {
                return OrganizationState.create($transition$.params().organizationId);
            }]
        }
    });

    $stateProvider.state("organization.details", {
        url: "/details",
        template: require('./organizations/organization.details.html'),
        controller: "OrganizationEditController as oec"
    });

    $stateProvider.state("organization.files", {
        url: "/files",
        controller: "OrganizationFilesController as ofc",
        template: require('./organizations/organization.files.html')
    });

    $stateProvider.state("organization.missions", {
        url: "?{mpid:guid}",
        controller: "OrganizationMissionsController as omc",
        template: require('./organizations/organization.missions.html'),
        params: {
            mpid: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        },
    });

    $stateProvider.state("organization.publish", {
        url: "/publish",
        template: require('./organizations/organization.publish.html'),
        controller: "OrganizationEditController as oec"
    });

    $stateProvider.state("organization.payroll", {
        url: "/payroll",
        template: require('./organizations/organization.payroll.html'),
        controller: "OrganizationEditController as oec"
    });

    $stateProvider.state("addorganization", {
        parent: 'authenticated',
        url: "/organizations/add",
        abstract: true,
        controller: "OrganizationController as oc",
        template: require('./organizations/addorganization.html'),
        data: { title: "Lägg till organisation" },
        resolve: {
            organizationState: ['OrganizationState', function (OrganizationState) {
                return OrganizationState.create();
            }]
        }
    });

    $stateProvider.state("addorganization.details", {
        url: "",
        template: require('./organizations/organization.details.html'),
        controller: "OrganizationEditController as oec"
    });

    $stateProvider.state("missions", {
        parent: 'authenticated',
        url: "/missions",
        template: require('./missions/missionList.html'),
        controller: 'MissionListController as ctrl',
        data: {
            title: "Historiska Uppdrag"
        },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("reports", {
        parent: 'authenticated',
        url: "/reports",
        template: require('./reports/reports.html'),
        controller: 'ReportsController as ctrl',
        data: {
            title: "Rapporter"
        }
    });

    $stateProvider.state("meetings", {
        parent: 'authenticated',
        url: "/meetings",
        abstract: true,
        controller: 'RootMeetingsController as ctrl',
        template: require('./meetings/search/meetings.root.html'),
        resolve: {
            meetingsShared: ['MeetingsShared', function (MeetingsShared) {
                return new MeetingsShared();
            }]
        }
    });

    $stateProvider.state("meetings.regular", {
        url: "",
        controller: 'RegularMeetingsController as ctrl',
        template: require('./meetings/search/meetings.regular.html'),
        data: { title: "Möten" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("meetings.tohandle", {
        url: "/tohandle",
        controller: 'MeetingsToHandleController as ctrl',
        template: require('./meetings/search/meetings.tohandle.html'),
        data: { title: "Möten - Att hantera" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("meetings.ceremony", {
        url: "/politiker",
        controller: 'CeremonyMeetingsController as ctrl',
        template: require('./meetings/search/meetings.ceremony.html'),
        data: { title: "Möten - Nya förrättningar" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("meetings.pending", {
        url: "/pending",
        controller: 'PendingMeetingsController as ctrl',
        template: require('./meetings/search/meetings.pending.html'),
        data: { title: "Möten - Väntar på attest" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("addmeeting", {
        parent: 'authenticated',
        url: "/meetings/add",
        abstract: true,
        controller: "MeetingController as meetingctrl",
        template: require('./meetings/detail/addmeeting.html'),
        data: { title: "Lägg till möte" },
        resolve: {
            meetingShared: ['MeetingState', function (MeetingState) {
                return MeetingState.create();
            }]
        }
    });

    $stateProvider.state("addmeeting.details", {
        url: "",
        template: require('./meetings/detail/meeting.details.html'),
        controller: "MeetingEditController as ctrl",
        params: {
            initialOrganizationId: null
        }
    });

    $stateProvider.state("meeting", {
        parent: 'authenticated',
        url: "/meetings/{meetingId:guid}",
        abstract: true,
        controller: "MeetingController as meetingctrl",
        template: require('./meetings/detail/meeting.html'),
        resolve: {
            meetingShared: ['$transition$', 'MeetingState', function ($transition$, MeetingState) {
                return MeetingState.create($transition$.params().meetingId);
            }]
        }
    });

    $stateProvider.state("meeting.details", {
        url: "",
        controller: "MeetingEditController as ctrl",
        template: require('./meetings/detail/meeting.details.html'),
        data: { title: "Möte - Uppgifter" }
    });

    $stateProvider.state("meeting.files", {
        url: "/files",
        controller: "MeetingFilesController as ctrl",
        template: require('./meetings/detail/meeting.files.html'),
        data: { title: "Möte - Dokument" }
    });

    $stateProvider.state("meeting.messages", {
        url: "/messages",
        controller: "MeetingMessagesController as ctrl",
        template: require('./meetings/detail/meeting.messages.html'),
        data: { title: "Möte - Meddelanden" }
    });

    $stateProvider.state("meeting.attendance", {
        url: "/attendance",
        controller: "AttendanceController as ctrl",
        template: require('./meetings/detail/meeting.attendance.html'),
        data: { title: "Möte - Närvaro" }
    });

    $stateProvider.state("meeting.payroll", {
        url: "/payroll",
        controller: "PayrollController as ctrl",
        template: require('./meetings/detail/meeting.payroll.html'),
        data: { title: "Möte - Arvoden" }
    });

    $stateProvider.state("parties", {
        parent: 'authenticated',
        url: "/parties",
        controller: "PartiesController as ctrl",
        template: require('./parties/parties.html'),
        data: { title: isTroman ? "Partier" : "Kategorier" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("missiontypes", {
        parent: 'authenticated',
        url: "/missiontypes",
        controller: "MissionTypesController as ctrl",
        template: require('./missionTypes/missionTypes.html'),
        data: { title: "Uppdragstyper" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("divisions", {
        parent: 'authenticated',
        url: "/divisions",
        controller: "DivisionsController as ctrl",
        template: require('./divisions/divisions.html'),
        data: { title: "Valkretsar" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("organizationtypes", {
        parent: 'authenticated',
        url: "/organizationtypes",
        controller: "OrganizationTypesController as ctrl",
        template: require('./organizationType/organizationTypes.html'),
        data: { title: "Organisationstyper" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("systemsettings", {
        parent: 'authenticated',
        url: "/systemsettings",
        controller: "SystemSettingsController as ctrl",
        template: require('./system/systemsettings.html'),
        data: { title: "Systeminställningar" }
    });

    $stateProvider.state("wagetypes", {
        parent: 'authenticated',
        url: "/wagetypes",
        controller: "WageTypesController as ctrl",
        template: require('./wageType/wageTypes.html'),
        data: { title: "Lönearter" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("wagecalculations", {
        parent: 'authenticated',
        url: "/wagecalculations",
        controller: "WageCalculationsController as ctrl",
        template: require('./wageCalculation/wageCalculations.html'),
        data: { title: "Beräkningsregler" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("wagegroups", {
        parent: 'authenticated',
        url: "/wagegroups",
        controller: "WageGroupsController as ctrl",
        template: require('./wageGroup/wageGroups.html'),
        data: { title: "Lönegrupper & Transaktioner" },
        params: {
            criteria: {
                dynamic: true,
            },
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("addwagegroup", {
        parent: 'authenticated',
        url: "/wagegroups/add",
        abstract: true,
        controller: "WageGroupController as wagegroupctrl",
        template: require('./wageGroup/wageGroup.html'),
        data: { title: "Lägg till lönegrupp" },
        resolve: {
            wageGroupShared: ['WageGroupState', function (WageGroupState) {
                return WageGroupState.create();
            }]
        }
    });

    $stateProvider.state("addwagegroup.details", {
        url: "",
        controller: "WageGroupDetailsController as ctrl",
        template: require('./wageGroup/wageGroup.details.html')
    });

    $stateProvider.state("wagegroup", {
        parent: 'authenticated',
        url: "/wagegroups/{wageGroupId:guid}",
        abstract: true,
        controller: "WageGroupController as wagegroupctrl",
        template: require('./wageGroup/wageGroup.html'),
        resolve: {
            wageGroupShared: ['$transition$', 'WageGroupState', function ($transition$, WageGroupState) {
                return WageGroupState.create($transition$.params().wageGroupId);
            }]
        }
    });

    $stateProvider.state("wagegroup.details", {
        url: "",
        controller: "WageGroupDetailsController as ctrl",
        template: require('./wageGroup/wageGroup.details.html'),
        data: { title: "Lönegrupp - Uppgifter" }
    });

    $stateProvider.state("wagegroup.organizations", {
        url: "/organizations",
        controller: "WageGroupOrganizationsController as ctrl",
        template: require('./wageGroup/wageGroup.organizations.html'),
        data: { title: "Lönegrupp - Organisationer" }
    });

    $stateProvider.state("wagegroup.transactions", {
        url: "/transactions",
        controller: "WageGroupTransactionsController as ctrl",
        template: require('./wageGroup/wageGroup.transactions.html'),
        data: { title: "Lönegrupp - Lönetransaktioner" }
    });

    $stateProvider.state("wagegroup.history", {
        url: "/history",
        controller: "WageGroupHistoryController as ctrl",
        template: require('./wageGroup/wageGroup.history.html'),
        data: { title: "Lönegrupp - Historik" }
    });
    
    $stateProvider.state("missiongroups", {
        parent: 'authenticated',
        url: "/missiongroups",
        controller: "MissionGroupsController as ctrl",
        template: require('./missionGroups/missionGroups.html'),
        data: { title: "Plocklistor" },
        params: {
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("addmissiongroup", {
        parent: 'authenticated',
        url: "/missiongroups/add",
        abstract: true,
        controller: "MissionGroupController as mgctrl",
        template: require('./missionGroups/addMissionGroup.html'),
        data: { title: "Lägg till plocklista" },
        resolve: {
            missionGroupShared: ['MissionGroupState', function (MissionGroupState) {
                return MissionGroupState.create();
            }]
        }
    });

    $stateProvider.state("addmissiongroup.details", {
        url: "",
        template: require('./missionGroups/missionGroup.details.html'),
        controller: "MissionGroupDetailsController as ctrl",
    });

    $stateProvider.state("missiongroup", {
        parent: 'authenticated',
        url: "/missiongroups/{missionGroupId:guid}",
        abstract: true,
        controller: "MissionGroupController as mgctrl",
        template: require('./missionGroups/missionGroup.html'),
        resolve: {
            missionGroupShared: ['$transition$', 'MissionGroupState', function ($transition$, MissionGroupState) {
                return MissionGroupState.create($transition$.params().missionGroupId);
            }]
        }
    });

    $stateProvider.state("missiongroup.details", {
        url: "/details",
        controller: "MissionGroupDetailsController as ctrl",
        template: require('./missionGroups/missionGroup.details.html'),
        data: { title: "Plocklista - Uppgifter" }
    });

    $stateProvider.state("missiongroup.missions", {
        url: "/",
        controller: "MissionGroupMissionsController as ctrl",
        template: require('./missionGroups/missionGroup.missions.html'),
        data: { title: "Plocklista" },
        params: {
            filter: {
                dynamic: true,
            }
        }
    });

    $stateProvider.state("ceremony", {
        parent: 'authenticated',
        url: "/politiker-meeting/{eventId:guid}",
        controller: "CeremonyController as ctrl",
        template: require('./meetings/ceremony/ceremony.html'),
        resolve: {
            eventId: ['$transition$', function ($transition$) {
                return $transition$.params().eventId;
            }]
        }
    });

    $stateProvider.state("politikersettings", {
        parent: 'authenticated',
        url: "/politiker-settings",
        controller: "PolitikerSettingsController as ctrl",
        template: require('./politikerSettings/politikerSettings.html'),
        data: { title: "Inställning för Troman Politiker" },
    });

    $stateProvider.state("pendingcertification", {
        parent: 'authenticated',
        url: "/pending-certification",
        controller: "PendingCertificationController as ctrl",
        template: require('./pendingCertification/pendingCertification.html'),
        data: { title: "Attestanter" },
        params: {
            filter: {
                dynamic: true,
            },
            filterPending: {
                dynamic: true,
            }
        }
    });

    $urlRouterProvider.otherwise("/");
}]);

angular.module('tromanWeb').service('tromanGlobals', function () {
    this.systemInfo = null;
    this.userProfile = null;
});

angular.module('tromanWeb').run(['$rootScope', '$transitions', '$timeout', 'isTroman', function ($rootScope, $transitions, $timeout, isTroman) {

    var pageTitle = isTroman ? 'Troman Webb' : 'Valman Webb';

    $rootScope.$shared = $rootScope.$shared || {};
    $rootScope.$shared.isTroman = isTroman;
    $rootScope.$shared.title = pageTitle;

    $transitions.onSuccess({}, function (transition) {
        var title = pageTitle;
        var toState = transition.to();
        if (toState && toState.data && toState.data.title) {
            title = pageTitle + " - " + toState.data.title;
        }
        // The change to document.location ($location.url) happens after the event is sent
        // because $location.url (during the next digest cycle).
        // Allow that change to happen before updating the title so
        // that browser history correctly matches title/url.
        //
        // It would probably also be possible to update the title in response to $locationChangeSuccess
        // But the same issue arises that the resulting transition would have to have started so that the target state can be found.
        $timeout(function () {
            $rootScope.$shared.title = title;
        });
    });
}]);

